import type { ExternalTeacherVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveExternalTeachers = createApiThunk<ExternalTeacherVM[], void>(
  "educationalAdvisor/externalTeachers/retrieve",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.listExternalTeachers();
  },
);
